import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const ComplianceCalendarPage = lazy(() => import("@/features/dashboard/pages/compliance-calendar"));

export const Route = createFileRoute("/(app)/dashboard/compliance-calendar")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading calendar…</div>}>
      <ComplianceCalendarPage />
    </Suspense>
  ),
});
